export const CartCtrlState = {
    UNINITIALIZED: 1,
    INITIALIZING: 2,
    INITIALIZED: 3,
    UPDATING: 4,
    UPDATED: 5,
    ERROR_MAX_ARTICLE: 6,
    ERROR: 7,
    ERROR_ALREADY_SAME_ARTICLE: 8,
    ERROR_OUT_OF_STOCK: 9
};
Object.freeze(CartCtrlState);

export class CartCtrl {

    constructor({orderId, initCartAccessoryApiUrl, cartUrl}) {
        this.orderId = orderId;
        this.state = orderId != null ? CartCtrlState.INITIALIZED : CartCtrlState.UNINITIALIZED;
        this.initCartAccessoryApiUrl = initCartAccessoryApiUrl;
        this.cartUrl = cartUrl;
    }

    /**
     * Ajoute un accessoire standalone au panier
     * @param idSeo idSeo de l'accessoire à ajouter
     * @param shop boutique sur laquelle à lieu l'ajout de l'accessoire
     * @return retourne une {Promise} pour l'ajout d'accessoire
     */
    addAccessory(idSeo, shop) {
        if (this.state === CartCtrlState.UNINITIALIZED) {
            return this.initAccessoryCart(idSeo, shop)
                .then((response) => {
                    this.orderId = response.orderId
                    this.cartUrl = response.tunnelUrl
                    return this.fetchCart(this.orderId)
                })
        } else {
            return this.updateAccessory(this.orderId, idSeo)
                .then(() => this.fetchCart(this.orderId))
        }
    }

    /**
     * Initialise le cart accessoire
     * @param idSeo idSeo de l'accessoire à ajouter
     * @param shop boutique sur laquelle à lieu l'ajout de l'accessoire
     * @return retourne une {Promise} pour l'init card
     */
    initAccessoryCart(idSeo, shop) {
        this.setState(CartCtrlState.INITIALIZING);
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo,
                shop: shop
            }
            $.ajax({
                method: "POST",
                url: this.initCartAccessoryApiUrl,
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done(data => {
                this.setState(CartCtrlState.UPDATED);
                resolve(data);
            }).fail(error => {
                this.setState(CartCtrlState.UNINITIALIZED);
                reject(error);
            });
        });
    }

    updateAccessory(orderId, idSeo) {
        this.setState(CartCtrlState.UPDATING);
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo
            }
            let url = `/api/mobile/orders/${orderId}/accessories`
            $.ajax({
                method: "POST",
                url: url,
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done(data => {
                resolve(data);
            }).fail(error => {
                if (error.status === 422) {
                    this.setState(CartCtrlState.ERROR_MAX_ARTICLE);
                } else if (error.status === 409) {
                    this.setState(CartCtrlState.ERROR_ALREADY_SAME_ARTICLE);
                } else if (error.status === 412) {
                    this.setState(CartCtrlState.ERROR_OUT_OF_STOCK);
                } else {
                    this.setState(CartCtrlState.ERROR);
                }
                reject(error);
            });
        });
    }

    /**
     * Récupère le cart courant
     */
    fetchCart(orderId) {

        let url =  `/api/mobile/orders/${orderId}/cartinfo`

        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: url,
                contentType: "application/json",
            }).done(data => {
                this.setState(CartCtrlState.UPDATED);
                resolve(data);
            }).fail(error => {
                this.setState(CartCtrlState.ERROR);
                reject(error);
            });
        });
    }

    setState(state) {
        this.state = state;
    }
}
